import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    modelValue: _ctx.localValue,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
      _cache[1] || (_cache[1] = (value) => _ctx.$emit('update:modelValue', parseInt(value)))
    ],
    "hide-bottom-space": "",
    dense: "",
    label: "Payment terms",
    "lazy-rules": "",
    outlined: "",
    type: "number",
    hint: "The value must be between 7 and 90 (days)"
  }, null, 8, ["modelValue"]))
}